import { get } from 'configs/axios/api_setup'

const BASE = 'google-pricing'

const toQuery = params =>
  Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '' && !(Array.isArray(v) && !v.length))
    .map(([k, v]) => `${k}=${encodeURIComponent(Array.isArray(v) ? v.join(',') : v)}`)
    .join('&')

// ** `get` from api_setup resolves with the axios error instead of rejecting: normalize it.
const request = async path => {
  const response = await get(path)
  if (!response || response instanceof Error || !response.data) {
    throw new Error(response?.response?.data?.message || response?.message || 'Request failed')
  }
  return response.data
}

export const getWorkspaceFilters = (refresh = false) =>
  request(`${BASE}/workspace/filters?${toQuery({ refresh: refresh || undefined })}`)

export const searchWorkspacePrices = params => request(`${BASE}/workspace/search?${toQuery(params)}`)

export const searchGcpServices = (q = '', limit = 50) => request(`${BASE}/gcp/services?${toQuery({ q, limit })}`)

export const searchGcpSkus = (serviceId, params) =>
  request(`${BASE}/gcp/services/${encodeURIComponent(serviceId)}/skus?${toQuery(params)}`)
